// API base URL for backend. Must end with /api when the server expects /api prefix.
// Set REACT_APP_API_URL in build (e.g. Vercel) for production; otherwise fallbacks apply.
const envUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// When app is served from production host but env wasn't set at build time (e.g. localhost baked in),
// use the production backend so tenant/auth API calls don't fail.
const isBrowser = typeof window !== 'undefined';
const isProductionHost =
  isBrowser &&
  !window.location.origin.includes('localhost') &&
  (window.location.origin.includes('tenantplus.co.ke') || window.location.origin.includes('vercel.app'));
const useProductionFallback = isProductionHost && envUrl.includes('localhost');

export const API_BASE_URL = useProductionFallback
  ? 'https://tenant-plus-backend.vercel.app/api'
  : envUrl.endsWith('/api')
    ? envUrl
    : `${envUrl.replace(/\/$/, '')}/api`;
